import React, { useEffect, useState } from 'react';
import {
    Button, CircularProgress, CssBaseline, Dialog, DialogActions,
    DialogContent, DialogTitle, Divider, Grid, Paper, Snackbar, Tooltip, Typography, useMediaQuery, useTheme
} from '@mui/material';
import { Alert, Timeline } from '@mui/lab';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CommonService } from '../../../services';
import SaveIcon from '@mui/icons-material/SaveOutlined';
import EditIcon from '@mui/icons-material/EditOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import ExportIcon from '@mui/icons-material/Publish';
import AuditTimeline from '../../common/AuditTimeline/AuditTimeline';
import useStyles from '../../common/CommonStyle/CommonStyle'
import { FormattedMessage, useIntl } from 'react-intl';
import { saveAs } from 'file-saver';

const PcnDtAuditHistory = (props) => {

    const classes = useStyles();
    let theme = useTheme();
    const intl = useIntl();
    const { onClose, open, pcnHdr, pcnDtl, isPcnAudtitHistrory, isBusinessPartnerPortal, msgIdValue,pcnNo , msgDtlsId} = props;
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const pageLabelsNamesAndConst = {
        labels: {
            dialogTitle: 'Delivery Confirmation Audit History',
            dialogTitleForPFT: 'Part Change Notification Time Line Chart History',
            cancel: 'Cancel',
            exportAuditHistory: 'Exp CFM ADT History',
            exportPFTAuditHistory: 'Exp PFT ADT History',
        },
    };

    const [recordsPerPage] = useState(30);
    const [pageNo, setPageNo] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [tableLoadingStatus, setTableLoadingStatus] = useState(true);
    const [isExportXlRequested, setExportXlRequested] = useState(false);
    const [alertBoxState, setAlertBoxState] = React.useState({
        openAlert: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: ''
    });
    const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
    const [data, setData] = useState([]);

    const handleCloseAlert = () => {
        setAlertBoxState({ ...alertBoxState, openAlert: false });
    };

    const handleClose = (value) => {
        onClose(value);
        setData([]);
        setPageNo(0);
    }
    const next = () => {
        setPageNo(pageNo + 1);
    }


    useEffect(() => {
        if (open) {
            fetchPoCfmDtAuditList();
        }
    }, [pcnHdr, open, pageNo]);

    function fetchPoCfmDtAuditList() {
        let tempData = data;
        setTableLoadingStatus(true);    
        CommonService.GetListApi(isPcnAudtitHistrory ? `/partChangeNotificationHdrs/${msgIdValue}/partChangeNotificationDtlsAuditView` : `/poOutboundSchAuditHistory`, {
            body: {
                partChangeNotificationDtls:  {
                    msgDtlsId: pcnDtl
                },
                pcnNo: pcnHdr !== undefined ? pcnHdr.pcnNo : '',
                batchId: pcnHdr !== undefined ? pcnHdr.batchId : '',
                latestDataSource: pcnHdr !== undefined ? pcnHdr.latestDataSource : ''
            },
            pageNo: pageNo,
            sortDir: 'desc',
            sortKey: 'partChangeNotiDtlsAuditId',
            recordsPerPage: recordsPerPage
        })
            .then((response) => {
                setTotalPageCount(response.data.totalPages);
                setData(tempData.concat(response.data.content));
                setTableLoadingStatus(false);
            })
            .catch(function (error) {
                if (error.response !== undefined) {
                    setTableLoadingStatus(false);
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                }
            });
    }

    function requestPcnDtAuditHistory() {
        setExportXlRequested(true);
        CommonService.saveOrUpdateOrPost(isPcnAudtitHistrory ? '/reports/PART_CHANGE_NOTIFICATION_DTL_HISTORY_REPORT' : ' ', {
            msgId: msgIdValue.toString(),
        })
            .then((response) => {
                // showDownloadPopUp(response.data.fileUrl)
                setExportXlRequested(false);
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="yourrequestno.snackbar.text" values={{ responsedata: `${response.data.value}`, reportName: `${response.data.reportName}` }} />, severity: "success" });
            })
            .catch(function (error) {
                if (error.response !== undefined) {
                    setExportXlRequested(false);
                    setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
                }
            });
    }

    const showDownloadPopUp = (filePath) => {
        const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll('\\', '/');
        const fileName = filePathReplaceWithDoubleBackwardSlash.split('/')[filePathReplaceWithDoubleBackwardSlash.split('/').length - 1].trim();
        fetch(`${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`, {
            method: 'GET',
            headers: {
                authorization: 'Bearer ' + CommonService.getJwtTokenOfLoggedInUser()
            },
        })

            .then((response) => {
                return response.blob();
            }
            )
            .then((blob) => {
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="successmessage.dowload" defaultMessage="File downloaded successfully" />, severity: "success" });
                saveAs(blob, fileName);
            })
            .catch(error => {
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="errorMessage.download" defaultMessage="Failed to download the file!" />, severity: "error" });
            })
    }


    return (
        <React.Fragment>
            <CssBaseline />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openAlert}
                onClose={handleCloseAlert}
                key={vertical + horizontal}
                autoHideDuration={6000}>
                <Alert onClose={handleCloseAlert} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
            <Grid container className={classes.root}>
                <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={12} lg={12}>
                    <Dialog fullWidth maxWidth='md' open={open}>
                        <DialogTitle className={classes.title}>
                            <Grid item container xs={12} sm={12} md={12} lg={12}>
                                <Grid item container alignItems='center' item xs={12} sm={6} md={6} lg={6} >
                                    <strong>{!isPcnAudtitHistrory ? <FormattedMessage id="PoAuditHistory.txt" defaultMessage={pageLabelsNamesAndConst.labels.dialogTitle} /> :
                                        <FormattedMessage id="PcnAuditHistory.txt" defaultMessage={pageLabelsNamesAndConst.labels.dialogTitleForPFT} />} - {pcnNo}
                                    </strong>
                                </Grid>
                                {<Grid container justifyContent='flex-end' alignItems='center' item xs={12} sm={6} md={6} lg={6}>
                                    <Button
                                        size='small'
                                        style={{ color: theme.palette.customText.main, fontWeight: 600 }}
                                        disabled={data.length <= 0 || isExportXlRequested}
                                        component="span"
                                        startIcon={<ExportIcon />}
                                        onClick={(() => {
                                            requestPcnDtAuditHistory();
                                        })}
                                        endIcon={isExportXlRequested ? <CircularProgress color="secondary" size={20} /> : null}
                                    > {!isPcnAudtitHistrory ? <FormattedMessage id="exppoDtladthistory.tooltip" /> : <FormattedMessage id="exppcnadthistory.tooltip" />}
                                    </Button>
                                </Grid>}
                            </Grid>
                        </DialogTitle>
                        <DialogContent id="scrollableDiv" dividers style={{ minHeight: '200px' }}>
                            {(data.length > 0) && (<InfiniteScroll
                                dataLength={data.length}
                                next={next}
                                hasMore={totalPageCount !== (pageNo + 1)}
                                scrollableTarget="scrollableDiv"
                                loader={
                                    <Grid container justifyContent={isMobile ? 'flex-start' : 'center'} alignItems='center' item xs={12} sm={12} md={12} lg={12}>
                                        <CircularProgress />
                                        <h6><FormattedMessage id="loading.text" defaultMessage="Loading....." /></h6>
                                    </Grid>}
                            >
                                <Timeline align={isMobile ? "left" : "alternate"}>
                                    {data &&
                                        data.map((pcnCfmDtAudit, index) => {
                                            let timelineIcon;
                                            let timelineColor;
                                            let timelineConnectorColor;
                                            let isLastNode = (data.length - 1) !== index;
                                            let title;
                                            let modifiedDate;
                                            let detailedMessage;
                                            let modifiedBy =
                                                pcnCfmDtAudit.partChangeNotificationDtls.updatedBy !== null && pcnCfmDtAudit.partChangeNotificationDtls.updatedBy !== ""
                                                    ? pcnCfmDtAudit.partChangeNotificationDtls.updatedBy
                                                    : intl.formatMessage({ id: "system.text" });
                                            if (pcnCfmDtAudit.recordStatus === 'INSERTED') {
                                                timelineIcon = <SaveIcon />;
                                                timelineColor = "primary";
                                                timelineConnectorColor = classes.primaryTail;
                                                modifiedDate = pcnCfmDtAudit.createdTimeDisp;


                                                const titlesAndDetailedMessages = [
                                                    {
                                                        title: <FormattedMessage id="pcnadtInserTitle1.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.confirm.text1"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    newFirstAnsDueDtDisp: `${pcnCfmDtAudit.newFirstAnsDueDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnadtInserTitle2.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.confirm.text2"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    newLastAnsDueDtDisp: `${pcnCfmDtAudit.newLastAnsDueDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnadtInserTitle3.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.confirm.text3"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    newLastTimeBuyDtDisp: `${pcnCfmDtAudit.newLastTimeBuyDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnadtInserTitle4.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.confirm.text4"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    newLastTimeShipmentDtDisp: `${pcnCfmDtAudit.newLastTimeShipmentDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },



                                                ];

                                                return titlesAndDetailedMessages.map((item, itemIndex) => (
                                                    <AuditTimeline
                                                        key={index + "-" + itemIndex}
                                                        timelineIcon={timelineIcon}
                                                        timelineColor={timelineColor}
                                                        timelineConnectorColor={item.timelineConnectorColor}
                                                        title={item.title}
                                                        isLastNode={isLastNode}
                                                        modifiedDate={modifiedDate}
                                                        modifiedBy={modifiedBy}
                                                        detailedMessage={item.detailedMessage}
                                                    />
                                                ));
                                            } else if (pcnCfmDtAudit.recordStatus === 'CHANGED') {
                                                timelineIcon = <EditIcon />;
                                                timelineColor = 'secondary';
                                                timelineConnectorColor = classes.secondaryTail;
                                                modifiedDate = pcnCfmDtAudit.createdTimeDisp;
                                                modifiedBy =
                                                    pcnCfmDtAudit.partChangeNotificationDtls.updatedBy !== null && pcnCfmDtAudit.partChangeNotificationDtls.updatedBy !== ""
                                                        ? pcnCfmDtAudit.partChangeNotificationDtls.updatedBy
                                                        : intl.formatMessage({ id: "system.text" });
                                                const titlesAndDetailedMessages = [
                                                    {
                                                        title: <FormattedMessage id="pcnAdtEditTitle1.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.edit.text1"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    oldFirstAnsDueDtDisp: `${pcnCfmDtAudit.oldFirstAnsDueDtDisp}`,
                                                                    newFirstAnsDueDtDisp: `${pcnCfmDtAudit.newFirstAnsDueDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnAdtEditTitle2.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.edit.text2"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    oldLastAnsDueDtDisp: `${pcnCfmDtAudit.oldLastAnsDueDtDisp}`,
                                                                    newLastAnsDueDtDisp: `${pcnCfmDtAudit.newLastAnsDueDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnAdtEditTitle3.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.edit.text3"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    oldLastTimeBuyDtDisp: `${pcnCfmDtAudit.oldLastTimeBuyDtDisp}`,
                                                                    newLastTimeBuyDtDisp: `${pcnCfmDtAudit.newLastTimeBuyDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },
                                                    {
                                                        title: <FormattedMessage id="pcnAdtEditTitle4.text" />,
                                                        detailedMessage: (
                                                            <FormattedMessage
                                                                id="pcn.detailedmessage.edit.text4"
                                                                values={{
                                                                    modified: `${modifiedBy}`,
                                                                    oldLastTimeShipmentDtDisp: `${pcnCfmDtAudit.oldLastTimeShipmentDtDisp}`,
                                                                    newLastTimeShipmentDtDisp: `${pcnCfmDtAudit.newLastTimeShipmentDtDisp}`,
                                                                }}
                                                            />
                                                        ),
                                                    },



                                                ];

                                                return titlesAndDetailedMessages.map((item, itemIndex) => (
                                                    <AuditTimeline
                                                        key={index + "-" + itemIndex}
                                                        timelineIcon={timelineIcon}
                                                        timelineColor={timelineColor}
                                                        timelineConnectorColor={item.timelineConnectorColor}
                                                        title={item.title}
                                                        isLastNode={isLastNode}
                                                        modifiedDate={modifiedDate}
                                                        modifiedBy={modifiedBy}
                                                        detailedMessage={item.detailedMessage}
                                                    />
                                                ));



                                            }

                                        })}
                                </Timeline>

                            </InfiniteScroll>)}
                            {tableLoadingStatus && (
                                <Paper style={{ marginTop: '25px', width: '100%' }}>
                                    <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={12} lg={12}>
                                        <CircularProgress color='primary' size={40} />
                                    </Grid>
                                </Paper>
                            )}
                            {(data.length <= 0 && !tableLoadingStatus) && (
                                <Paper style={{ marginTop: '25px', width: '100%' }}>
                                    <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant='body2' noWrap={true} className={classes.boldHeaderForNoRows}><FormattedMessage id="norows.label" defaultMessage="No rows" /></Typography>
                                    </Grid>
                                </Paper>
                            )}
                        </DialogContent>
                        {!isMobile && (
                            <DialogActions className={classes.dialogAction} >
                                <Grid container justifyContent='flex-end' item xs={12} sm={12} md={12} lg={12} className={classes.commonDialogButtonSpacing} >
                                    <Button size='small' variant="contained" color="primary" className={classes.cancelbuttonSpacing} elevation={2} endIcon={<ClearIcon />}
                                        onClick={() => handleClose(false)}
                                    ><FormattedMessage id="common.button.cancel.lable" defaultMessage="Cancel" />
                                    </Button>
                                </Grid>
                            </DialogActions>)}
                        {isMobile && (<Grid container justifyContent='center' alignItems='center' item xs={12} sm={12} md={12} lg={12}>
                            <DialogActions className={classes.dialogAction}>
                                <Grid container justifyContent='flex-end' alignItems='center' item xs={12} sm={12} md={12} lg={12} className={classes.topGrid} >
                                    <Tooltip title={<FormattedMessage id="common.button.cancel.lable" />}>
                                        <Button size='small' variant="contained" color="primary" className={classes.cancelbuttonSpacing} elevation={2}
                                            onClick={() => handleClose(false)}
                                        >  <ClearIcon />
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </DialogActions>
                        </Grid>)}
                    </Dialog>
                </Grid>
            </Grid>
        </React.Fragment >
    );
}

export default PcnDtAuditHistory;
